import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import {CssBaseline, Typography, Stack, Card as MuiCard, styled, Box } from '@mui/material';
import TextAreaWithButton from '../components/common/TextAreaWithButton';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import ContactUs from '../components/feature-specific/ContactUs';
// import HorizontalStepper from '../components/common/HorizontalStepper';
// import { useVerification } from '../VerificationContext';
import Aadhar from './Aadhar';
// import Pan from './Pan';
import PopUpAlert from '../components/common/PopUpAlert';
import Banner from '../components/feature-specific/Banner';
import { useSnackbar } from '../SnackbarProvider';
import BankDetails from './Bank';
import HorizontalStepper from '../components/common/HorizontalStepper';

const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    marginTop:"0px",
    [theme.breakpoints.up('sm')]: {
      maxWidth: '450px',
    },
    boxShadow:
      'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  }));
  
  const SignInContainer = styled(Stack)(({ theme }) => ({
    padding: "10px",
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      zIndex: -1,
      inset: 0,
      backgroundImage:
        'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
      backgroundRepeat: 'no-repeat',
      ...theme.applyStyles('dark', {
        backgroundImage:
          'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
      }),
    },
  }));

  const InputWrapper = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(3.2), // Adjust this value as needed
    position: 'relative',
  }));
  

  const KYCVerification: React.FC = () => {
    const [pan, setPan] = useState<string>(''); // Type for pan state
    const [panError, setPanError] = useState<boolean>(false); // Type for panError state
    const [errorMessage,setErrorMessage] = useState<string>('');
    const [isLoading,setIsLoading] = useState<boolean>(false);
    const [panVerified,setPanVerified] = useState<boolean>(false);
    const [panNameMatch,setPanNameMatch] = useState<boolean>(false);
    const {showSnackbar} = useSnackbar();
    const navigate = useNavigate();
    const location = useLocation();
    const {id , phone} = location.state || {};
    const [user,setUser]=useState<{id:any,phone:any}>({id:"",phone:""})
    const [warningLevel,setWarningLevel] = useState(true);
    const [currentStep, setCurrentStep] = useState<number>(0)
    const [prevAadhar,setPrevAadhar] = useState<{id:string,status:boolean}>({id:"",status:false});
    const [prevBank,setPrevBank] = useState<{id:string,status:boolean}>({id:"",status:false});
    const [tncStatus,setTncStatus] = useState<boolean>(false);
    const [aadhar, setAadhar] = useState<string>(''); // Aadhar state typed as string
    const [isAadharVerified,setIsAadharVerified] = useState<boolean>(false);
    const [aadharNameMatch,setAadharNameMatch] = useState<boolean>(true);
    const [bankAcc, setBankAcc] = useState<string>(''); // State for bank account
    const [ifsc, setIfsc] = useState<string>(''); // State for IFSC code
    const [bankVerified, setBankVerified] = useState<boolean>(false);
    const [bankNameMatch,setBankNameMatch] = useState<boolean>(true);
    
        interface  JourneyStatusResponse{
          doc_type: string;
          identity_number: string ;
          verification_status: boolean;
        }

        interface KycJourneyApiResponse {
          responseCode: number;
          responseMessage: string;
          data: JourneyStatusResponse[];
        }

        const token = localStorage.getItem('authToken');
            const headers = {
              Authorization: `Bearer ${token}`,
            };
          
  const [shouldFetchStatus, setShouldFetchStatus] = useState(false);

  useEffect(() => {
    const fetchStatus = async () => {
      const phone = localStorage.getItem("mobile");
      const id = localStorage.getItem("id");
      if (phone && id) {
                  try{
          const response = await axios.get<KycJourneyApiResponse>(`https://promoter-api.benow.in/api/kyc/v1/auth/kycJourneyStatus/${phone}`,{headers})

          const aadharStatus:(JourneyStatusResponse|undefined) = response.data.data.find((doc) => doc.doc_type === 'AADHAR');
          const panStatus:(JourneyStatusResponse|undefined) = response.data.data.find((doc) => doc.doc_type === 'PAN');
          const bankStatus:(JourneyStatusResponse|undefined) = response.data.data.find((doc) => doc.doc_type === 'BANK');
          const tncStatus:(JourneyStatusResponse|undefined) = response.data.data.find((doc)=>doc.doc_type==='TNC');
            console.log(panStatus);
    // Handle each document type
    if (aadharStatus) {
      setAadhar(aadharStatus.identity_number);
      setCurrentStep(2);
      setAadharNameMatch(aadharStatus.verification_status);
      setIsAadharVerified(true);
      setPrevAadhar({ id: aadharStatus.identity_number, status: aadharStatus.verification_status });
    }

    if (panStatus) {
      // console.log('1');
      setCurrentStep(1);
      console.log(panStatus);
      setPan(panStatus.identity_number);
      setPanVerified(true);
      if (panStatus.verification_status) {
        setPanNameMatch(true);
      } else {
        setPanNameMatch(false);
        // setPanError(true);
        setWarningLevel(true);
        setErrorMessage('Your details will be verified manually.');
      }
    }

    if (bankStatus) {
      // Handle Bank status
      setBankAcc(bankStatus.identity_number);
      setCurrentStep(3);
      setIfsc('XXXXXXXXXX');
      setBankNameMatch(bankStatus.verification_status);
      setBankVerified(true);
      // setPrevAadhar({ id: aadharStatus.identity_number, status: aadharStatus.verification_status });
    }
    if(tncStatus){
      if(prevAadhar && pan && bankStatus){
        navigate('/summary',{state:{aadharNameMatch:aadharStatus?.verification_status,panNameMatch:panStatus?.verification_status,bankNameMatch:bankStatus?.verification_status }})
      }
    }
    } catch (error) {
      console.error("Error fetching KYC journey status:", error);
      // Handle error response
    }
      }
    };
  
    fetchStatus();
  }, []);

useEffect(() => {
  const setUserAndFetch = async () => {
    let userPhone, userId;
    if (phone && id) {
      userPhone = phone;
      userId = id;
    } else {
      userPhone = localStorage.getItem("mobile");
      userId = localStorage.getItem("id");
    }
    
    if (userPhone && userId) {
      setUser({phone: userPhone, id: userId});
      setShouldFetchStatus(true);
    }
  };

  setUserAndFetch();
}, []);

        interface UserDataResponse {
          responseCode: number;
          responseMessage: string;
          data:{
            verificationStatus: boolean;
          }
        }

        // Validate PAN using regex
        const validatePan = (value: string): boolean => {
          const panRegex = /^[A-Za-z]{5}\d{4}[A-Za-z]$/;
          const isValid = panRegex.test(value);
          setPanError(!isValid); // Set error based on regex match
          return isValid;
        };
        
        const handlePanChange = (value: string): void => {
          setErrorMessage('');
          setPanError(false);
          setPan(value); // Convert the string to uppercase
        };
        // Handle PAN submission and call backend API using Axios
          const handleSubmit = async () => {
          const token = localStorage.getItem('authToken');
          const headers = {
            Authorization: `Bearer ${token}`,
          };
          if (validatePan(pan)) {
            setErrorMessage('');
            try {
              const a=true;
              setIsLoading(true);
              const phone = localStorage.getItem('mobile');
              const id = localStorage.getItem('id');
              const response = await axios.post<UserDataResponse>('https://promoter-api.benow.in/api/kyc/v1/auth/register', { merchantId:id, mobileNumber:phone ,identityNumber:pan.toUpperCase(),actionType:"2" },
                { headers}
              );
              console.log(response.data.data.verificationStatus);
              console.log(response.status);
              
              if (response.status === 200 && response.data.data.verificationStatus===true) {
                setPanVerified(true);
                setCurrentStep(1);
                setPanNameMatch(true);
                showSnackbar("PAN Verified Successfully",'success');
                setIsLoading(false);
              } 
              else if(response.status === 200 && response.data.data.verificationStatus===false){
                showSnackbar("Name Mismatch.",'warning');
                setPanVerified(true);
                setPanNameMatch(false);
                setCurrentStep(1);
                setIsLoading(false);
                setWarningLevel(true);
                setErrorMessage('Your details will be verified manually.');
              }
              else{
                showSnackbar("Server Error.",'warning');
                setPanVerified(true);
                setPanNameMatch(false);
                setCurrentStep(1);
                setIsLoading(false);
                setWarningLevel(true);
                setErrorMessage(' Your details will be verified manually.');
              }
            } catch (error:any) {
              if(error.status===404){
                  showSnackbar("Invalid PAN Card. Please try again.",'error');
                  setWarningLevel(false);
                  setErrorMessage('Invalid PAN Card.');
                  setIsLoading(false);
              }
              else{
                  showSnackbar("Unexpected Error Occurred. Try again later.",'warning');
                  setWarningLevel(false);
                  setErrorMessage('Server Error.Your details will be verified manually.');
                  setIsLoading(false);
              }
            }
          } else {
            setWarningLevel(false);
            setErrorMessage('Invalid PAN. Format: 5 letters, 4 digits, 1 letter.')
          }
        };
    return (
        <div>
          <CssBaseline enableColorScheme />
          <Banner/>
          <SignInContainer direction="column" justifyContent="space-between">
            <Card variant='outlined'>
              <InputWrapper>
          <Typography component="h1" variant="h4" sx={{ textAlign: 'center'}}>
            KYC Verification
          </Typography>
              </InputWrapper>
              <InputWrapper>
                <HorizontalStepper activeStep={currentStep}/>
              </InputWrapper>
              <InputWrapper>
          <TextAreaWithButton
          errorMessage={panError ? 'Invalid PAN. Format: 5 letters, 4 digits, 1 letter.' :errorMessage}
          label="PAN Number"
          inputValue={pan}
          onChange={handlePanChange}
          onClick={handleSubmit}
          buttonText="validate"
          ariaLabel="pan"
          disabled={isLoading}
          verified={panVerified}
          />
        {errorMessage && (
        <Typography 
          color={warningLevel ? 'orange' : 'error'} 
          fontSize="10px" 
          position="absolute" 
          bottom="-30px"
        >
          {errorMessage}
        </Typography>
)}
              </InputWrapper>
        
          <Aadhar mobileNumber={phone} id={id} textDisabled={!panVerified} setCurrentStep={setCurrentStep} panNameMatch={panNameMatch} aadharStatus={prevAadhar} bankStatus={prevBank}
          aadhar={aadhar}
          setAadhar={setAadhar}
          aadharNameMatch ={aadharNameMatch}
          setAadharNameMatch = {setAadharNameMatch}
          isAadharVerified = {isAadharVerified}
          setIsAadharVerified = {setIsAadharVerified}
          bankAcc={bankAcc}
          setBankAcc={setBankAcc}
          ifsc={ifsc}
          setIfsc={setIfsc}
          bankNameMatch={bankNameMatch}
          setBankNameMatch={setBankNameMatch}
          bankVerified={bankVerified}
          setBankVerified={setBankVerified}
          />
            </Card>
          </SignInContainer>
        </div>
      );
}

export default KYCVerification